import BVAInput from "../../../components/BVAInput/BVAInput";

export default function Item({ id, name, data, handleChange = () => {}, bold = false, disabled = false, endLabel = "$", bg = "" }) {
  return (
    <div id={id} className={`flex justify-between items-center my-3 px-5 ${bg !== "" ? "py-3 rounded-lg " + bg : ""}`}>
      <div className={`items-center text-lg ${bold ? "font-semibold" : ""}`}>{name}</div>
      <BVAInput
        size="small"
        width="170px"
        textAlign="start"
        disabled={disabled}
        endAdornment
        endAdornmentLabel={endLabel}
        value={data}
        onChange={handleChange}
      />
    </div>
  );
}
